/**
 * Helper
 */
var helper = require('../../helper');

$(function() {

    var $datatable = $('#datatable-all-guardian-queries'),
       
        dataTables_buttons = [
            {
                extend: 'colvis'
            }
        ];

        var table = $datatable.DataTable({
            "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
            "processing": true,
            "serverSide": true,
            "responsive": true,
            "lengthMenu": [[ 10, 25, 50, 75, 100], [ 10, 25, 50, 75, 100]],
            "ajax": helper.getOrigin() + "/api/guardian-query/",
            "autoWidth" : false,
            "buttons": dataTables_buttons,
            "order": [[ 0, "desc" ]],
            "columns": [
                {data: 'id', name: 'id'},
                {data: 'created_at', name: 'created_at'},
                {data: 'closed_at', name: 'closed_at'},
                {data: 'status_id', name: 'status_id'},
                {data: 'guardian_id', name: 'guardian_id'},
                {
                    data: 'actions',
                    name: 'actions',
                    orderable: false,
                    searchable: false,
                    className : "action"
                }
            ],
            'columnDefs': [
                {
                    'targets': 3,
                    'searchable':true,
                    'orderable':false,
                    'className': 'dt-body-center tiny-column',
                    'render': function (data){
                        console.log(data);
                        if (data == 0) { // if field in database is 1 (checked)
                            return '<span class="label" style="background-color: #006cff;"> New Query</span>';
                        } else if (data == 1) { 
                            return '<span class="label" style="background-color: #034ea2;"> Global Guardians Replied</span>';
                        } else if (data == 2) { 
                            return '<span class="label" style="background-color: #2FC694;"> Guardian Replied </span>';
                        } else if (data == 3) { 
                            return '<span class="label" style="background-color: #ed4d5e"> Closed </span>';
                        } else {
                            return '';
                        }
                    }
                },
                
            ]
        });

    });
